<template>
  <!-- Begin Special Offers -->
    <div class="uren-banner_area uren-banner_area-2">
      <h2 class="text-center"><span class="text-primary-custom">Special</span> Offers</h2>
      <div class="container-fluid">
        <div class="row">
          <div v-for="offer in offers" :key="offer.name" class="col-lg-4 col-md-6">
            <div class="banner-item"> <!-- that tag had the following class: img-hover_effect -->
                <img class="img-full" :src="offer.img" :alt="offer.name">
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- Special Offers End Here -->
</template>

<script>
export default {
  name: "SpecialOffers",
  data() {
    return {
      offers: [
        {
          name: "Best Tools",
          img: "/images/banner/1-3.jpg",
        },
        {
          name: "40%",
          img: "/images/banner/1-4.jpg",
        },
        {
          name: "30%",
          img: "/images/banner/1-5.jpg",
        },
      ]
    }
  }
}
</script>

<style>

</style>
